import { Button, Modal, Switch } from "antd";
import { useState } from "react";

import { useLeadFormActions } from "./hooks/useLeadFormActions";
import { configType } from "../../constant/WebToLead";

const Status = ({ record, row, page }) => {
  const [isConfirm, setConfirm] = useState(false);
  const { handleStatus } = useLeadFormActions(
    () => {},
    () => setConfirm(true)
  );

  return (
    <>
      <Switch
        disabled={row?.configType !== configType.SHARED_URL}
        value={record}
        onChange={() => handleStatus(row, page)}
      />
      <Modal
        title="Subscription expired"
        open={isConfirm}
        centered
        width={400}
        footer={[
          <Button
            key="cancel"
            className="secondary-btn"
            onClick={() => setConfirm(false)}
          >
            No
          </Button>,
          <Button
            key="ok"
            type="primary"
            className="theme-btn"
            onClick={() => {
              handleStatus({ ...row, force: true }, page);
              setConfirm(false);
            }}
          >
            Yes
          </Button>,
        ]}
        onOk={() => setConfirm(false)}
        onCancel={() => setConfirm(false)}
      >
        Your subscription has expired, but the grace period is still active. Do
        you want to continue for up to 7 more days?
      </Modal>
    </>
  );
};

export default Status;
